import { createAPI } from '@common'
export default {
  // 分辨率设置
  getScreenControlConfig: config => createAPI('customEncryptApiName-1/0w20tdsffo0dpouspm0dpogjh', 'GET', config),
  postScreenControlConfig: config => createAPI('customEncryptApiName-1/0w20tdsffo0dpouspm0dpogjh', 'POST', config),
  // 新建组装页面
  postScreenControlPages: config => createAPI('customEncryptApiName-1/0w20tdsffo0dpouspm0qbhft', 'POST', config),
  getScreenControlPages: config => createAPI('customEncryptApiName-1/0w20tdsffo0dpouspm0qbhft', 'GET', config),
  // 删除
  postScreenControlPagesDelete: config => createAPI('customEncryptApiName-1/w20tdsffo0dpouspm0qbhft0efmfuf', 'POST', config),
  // 读组装设置
  getScreenControlPagesConfig: (config, vconfig) => createAPI('customEncryptApiName-1/0w20tdsffo0dpouspm0qbhft0dpogjh', 'GET', config, vconfig),
  // 提交页面的组装设置
  postScreenControlPagesConfig: config => createAPI('customEncryptApiName-1/0w20tdsffo0dpouspm0qbhft0dpogjh', 'POST', config),
  // 读大屏组件列表
  getScreenControlModulesList: config => createAPI('customEncryptApiName-1/0w20tdsffo0dpouspm0npevmft0mjtu', 'GET', config),
  // 增加/修改外链组件
  postScreenControlModules: config => createAPI('customEncryptApiName-1/0w20tdsffo0dpouspm0npevmft', 'POST', config),
  // 删除外链组件
  deleteScreenControlModules: config => createAPI('customEncryptApiName-1/0w20tdsffo0dpouspm0npevmft', 'DELETE', config)
}
